// Anon-safe column allow-list for public `service_offerings` reads.
//
// `contact_email` (the creator's private address for sponsorship enquiries)
// is being REVOKED from `anon` at the Postgres privilege level. After that,
// any anon `select('*')` on service_offerings returns 403 (42501), so public /
// logged-out pages (bio page, collab checkout) MUST select this list instead.
// Sponsor enquiries reach the creator through send-sponsor-inquiry, which
// reads the address server-side.
//
// Columns intentionally EXCLUDED (never expose to anon): contact_email
//
// anon's access is a COLUMN grant of exactly this list. To show a new column
// on a public page, add it here AND to the grant in a migration, or the read
// will 403. serviceOfferingColumns.test.ts checks the fields the public pages
// render.
export const PUBLIC_SERVICE_OFFERING_COLUMNS = [
  'id', 'talent_id', 'service_type', 'pricing', 'title', 'description',
  'video_length_seconds', 'benefits', 'is_active', 'display_order',
  'created_at', 'updated_at', 'platforms', 'total_followers', 'coupon_code',
  'coupon_discount_amount', 'coupon_discount_type', 'is_recurring',
  'recurring_interval',
].join(',');
